/// <reference path="../../common/resources/resources.ts" />
/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../../teva/dropdown/dropdown.ts" />
/// <reference path="../../../teva/navigation/navigation.ts" />

namespace OfficeGuy.CRM {
    export class EntityDetails {
        static Init() {
            $(document.body)
                .on("click.longtext-close", ".sumit-longtext-toggle-close", function () {
                    $(this).closest(".sumit-longtext").removeClass("sumit-longtext-open");
                    $(this).closest(".sumit-longtext").find(".sumit-longtext-text").slideUp();
                    return false;
                })
                .on("click.longtext-open", ".sumit-longtext-toggle-open", function () {
                    $(this).closest(".sumit-longtext").addClass("sumit-longtext-open");
                    $(this).closest(".sumit-longtext").find(".sumit-longtext-text").slideDown();
                    return false;
                })
                .on("click.entityvalues-close", ".og-entity-values-close", function (Event) {
                    EntityDetails.MultipleValuesField_Toggle(this, false);
                    Event.stopPropagation();
                    Event.preventDefault();
                    return false;
                })
                .on("click.entityvalues-open", ".og-entity-values-open", function (Event) {
                    EntityDetails.MultipleValuesField_Toggle(this, true);
                    Event.stopPropagation();
                    Event.preventDefault();
                    return false;
                });
        }

        static MultipleValuesField_Toggle(Element: Element, Show: boolean): void {
            if (!Show) {
                $(document).trigger("click.multiplevalues");
                return;
            }

            var $Container = $(Element).closest(".og-entity-values");
            var $Collapse = $Container.find("> .og-entity-values-collapse-container");
            Teva.Dropdown.PositionMenu($Container, $Collapse);
            $Collapse.fadeIn(200);

            OfficeGuy.Common.Tooltip_Hide();
            $Container.addClass("og-entity-values-opened");
            $(document).trigger("click.multiplevalues");
            $(document).on("click.multiplevalues", function (Event) {
                if ($(Event.target).closest(".og-entity-values").length > 0)
                    return;

                $Collapse.fadeOut(200);
                $Container.removeClass("og-entity-values-opened");
                $(document).off("click.multiplevalues");
            });
        }

        static InitKeyboardShortcuts(SchemaID, EntityID, AllowCreate, AllowEdit, AllowDuplicate) {
            var $Document = $(document);
            if (AllowCreate == 1) {
                $Document.on("keyup.altc", null, "alt+c", function (Event) {
                    // Create
                    Navigation.Redirect("/f" + SchemaID + "/new/");
                    Event.preventDefault();
                    Event.stopPropagation();
                    return false;
                });
            }
            if (AllowEdit == 1) {
                $Document.on("keyup.altw", null, "alt+w", function (Event) {
                    // Edit
                    Navigation.Redirect("/f" + SchemaID + "/c" + EntityID + "/edit/");
                    Event.preventDefault();
                    Event.stopPropagation();
                    return false;
                });
            }
            if (AllowDuplicate == 1) {
                $Document.on("keyup.altt", null, "alt+t", function (Event) {
                    // Duplicate
                    Navigation.Redirect("/f" + SchemaID + "/new/?EntityIDToCopy=" + EntityID);
                    Event.preventDefault();
                    Event.stopPropagation();
                    return false;
                });
            }
        }

        static InitQuickEdit() {
            if (Common.IsBrowserLowResolution())
                return;

            var $EditButton = $(".crm-entity-quickedit");
            if ($EditButton.length == 0) {
                $EditButton = $(document.createElement('div'))
                    .addClass("crm-entity-quickedit")
                    .attr("title", Resources.GetString("CRM", "Edit"));
            }
            else
                $EditButton.off("click.quickedit");

            var $EditButtonDisplayField;
            $(document)
                .off("mouseenter.quickedit")
                .on("mouseenter.quickedit", ".sumit-field-editable .sumit-field-value", function () {
                    $EditButtonDisplayField = $(this);
                    $EditButton
                        .appendTo($EditButtonDisplayField)
                        .show();
                })
                .off("mouseleave.quickedit")
                .on("mouseleave.quickedit", ".sumit-field-editable .sumit-field-value", function () {
                    $EditButton.hide();
                    $(document.body).append($EditButton);
                });
            $EditButton.on("click.quickedit", function (Event) {
                if ($EditButtonDisplayField == null)
                    return true;

                var PropertyID = $EditButtonDisplayField.data("propertyid");
                var SchemaID = $EditButtonDisplayField.closest(".crm-entity").data("schemaid");
                var EntityID = $EditButtonDisplayField.closest(".crm-entity").data("entityid");

                var URL = "/f" + SchemaID + "/c" + EntityID + "/p" + PropertyID + "/";
                if (Teva.Navigation.IsNewWindowEvent(Event))
                    window.open(URL);
                else {
                    var Modal = Modals.ShowHTMLGetDialog({
                        URL: URL + "?isentity=true",
                        FullURL: URL,
                        ReplaceModal: true,
                        ConvertToAjax: true,
                        ConvertToAjax_PreRenderEvent: function (ResultData) {
                            if (typeof (ResultData) != "string" && ResultData.CustomData != null && ResultData.CustomData.HTML != null) {
                                if (ResultData.Notifications != null) {
                                    setTimeout(function () {
                                        Notifications.Show(ResultData.Notifications);
                                    }, 200);
                                }
                                $EditButtonDisplayField.closest(".sumit-field").replaceWith(ResultData.CustomData.HTML);
                                Modals.Hide(Modal);
                                return true;
                            }
                            return false;
                        }
                    });
                }
                Event.stopPropagation();
                return false;
            });
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.CRM.EntityDetails.Init();
});
